import * as React from 'react';
const SvgDetailAid = (props) => (
  <svg viewBox="0 0 124 124" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m54.257 54.256 25.315 8.894 40.16 40.16a7.741 7.741 0 0 1 0 10.949l-5.472 5.473a7.742 7.742 0 0 1-10.95 0l-40.16-40.16-8.893-25.316ZM60.16 56.332l-3.92 3.576"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m64.839 81.25 8.53-7.896 32.385 31.978-8.415 8.429M17.483 17.483c0 3.208-3.464 5.807-7.741 5.807C5.464 23.29 2 20.69 2 17.483s3.464-5.806 7.742-5.806M17.483 38.773c0 3.208-3.464 5.806-7.741 5.806C5.464 44.58 2 41.981 2 38.773s3.464-5.806 7.742-5.806M17.483 60.063c0 3.208-3.464 5.806-7.741 5.806C5.464 65.869 2 63.271 2 60.063s3.464-5.806 7.742-5.806M17.483 81.352c0 3.208-3.464 5.807-7.741 5.807C5.464 87.159 2 84.56 2 81.352s3.464-5.806 7.742-5.806M17.483 102.642c0 3.208-3.464 5.806-7.741 5.806-4.278 0-7.742-2.598-7.742-5.806s3.464-5.806 7.742-5.806"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.742 13.613V2h87.094v56.127M9.742 34.902V23.29M9.742 56.192V44.579M9.742 77.482V65.869M9.742 98.771V87.16M81.353 118.125H9.743v-9.677"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M81.352 50.386c-1.935-13.548-15.483-21.29-29.031-21.29-13.548 0-23.225 9.677-23.225 19.354 0 6.614 3.87 15.484 13.548 15.484 5.806 0 11.612-3.871 11.612-9.677"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgDetailAid;
